import type { FilterConfigurationResponse } from "../components/FilterKit/types";
import { reactQueryGet } from "../helpers/backendRequestHelpers";
import { crmFilters } from "../helpers/urlHelpers/internalApi/crmFilters";

const configuration = () =>
  reactQueryGet<FilterConfigurationResponse>(crmFilters.configuration());

export const crmFiltersApi = {
  configuration,
};
